import { GlobalElementsConfig, LineOfBusinessConfig, PageBrand } from '../types'

const geConfig: GlobalElementsConfig = {
  header: 'wise',
  footer: 'wise',
}

const pageBrand: PageBrand = 'corporate'

export const wise = new LineOfBusinessConfig(geConfig, pageBrand)
